import { instance as api } from '@/helpers/api'
import { TeamMitglied } from '@/models/TeamMitglied'
import { createModel } from '@kp/js-model'
import { ref, type Ref } from 'vue'

const teamRequests: Ref<TeamMitglied[]> = ref([])

export async function updateTeamRequests() {
    const res = await api().get('/team/loadTeamRequests')
    teamRequests.value = []
    res.data.records.forEach((r: TeamMitglied[]) =>
        teamRequests.value.push(createModel(TeamMitglied, r)),
    )
}

export function useTeamRequests(): Ref<TeamMitglied[]> {
    return teamRequests
}
